// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7d1eab38","736":"21e18399"}[chunkId] + ".chunk.js";
};